import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { Switch } from '@eventespresso/ui-components';
import { __ } from '@eventespresso/i18n';

import { HtmlEditor } from './HtmlEditor';
import { PlainTextEditor } from './PlainTextEditor';
import { useRichTextEditor } from './useRichTextEditor';

import type { RichTextEditorProps } from './types';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './style.scss';

export const RichTextEditor: React.FC<RichTextEditorProps> = ({
	className,
	defaultValue,
	onChange,
	onChangeValue,
	placeholder,
	value,
	...props
}) => {
	const {
		editorProps,
		isTextMode,
		plainText,
		editorRef,
		handlePlainTextChange,
		onEditorStateChange,
		handleModeSwitch,
	} = useRichTextEditor({
		value,
		defaultValue,
		onChange,
		onChangeValue,
	});

	const htmlEditorProps = {
		...props,
		...editorProps,
		onEditorStateChange,
		placeholder,
		editorRef,
		className,
	};

	return (
		<>
			<Box mb='6' px='6' display='flex' alignItems='center' fontSize='md'>
				<Text fontWeight='600'>{__('Mode')}</Text>&nbsp;&nbsp;
				<Switch isChecked={isTextMode} onChange={handleModeSwitch} display='inline-flex'>
					<Text fontWeight='400'>
						{isTextMode
							? __('Text Mode - click to switch to html mode')
							: __('Html Mode - click to switch to plaintext mode')}
					</Text>
				</Switch>
			</Box>
			{isTextMode ? (
				<PlainTextEditor value={plainText} onChange={handlePlainTextChange} placeholder={placeholder} />
			) : (
				<HtmlEditor {...htmlEditorProps} />
			)}
		</>
	);
};
